import { Create } from 'react-admin'

import PodcasterForm from './PodcasterForm'

const PodcasterCreate = props => (
  <Create redirect="list" {...props}>
    <PodcasterForm isCreating permissions={props.permissions} />
  </Create>
)

export default PodcasterCreate
